<template>
  <div class="columns is-multiline">
    <div class="column is-12">
      <div class="card contactEdition">
        <div class="header-card">
          <p>
            {{ title }}
          </p>
        </div>
        <div class="card-content">
          <b-field
            custom-class="has-text-weight-normal is-italic is-marginless">
            <span class="has-text-weight-bold">
              {{ texte }}
            </span>
          </b-field>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  props: {
    title: {
      type: String,
      required: true,
    },
    texte: {
      type: [String, null],
      required: false,
      default: '',
    },
  },
};
</script>

<style>

</style>
